import { firebase } from "@firebase/app";
import "@firebase/auth";
import "@firebase/database";
import "@firebase/storage";
var firebaseConfig = {
  apiKey: "AIzaSyAyEFxhX-8WONAnXM21SCeVmnp7M3rYu_k",
  authDomain: "easypharma-81c6a.firebaseapp.com",
  databaseURL: "https://easypharma-81c6a.firebaseio.com",
  projectId: "easypharma-81c6a",
  storageBucket: "easypharma-81c6a.appspot.com",
  messagingSenderId: "250431931967",
  appId: "1:250431931967:web:651991686eff8c58531a8a"
};
export const fapp = firebase.initializeApp(firebaseConfig);
export const storage = firebase.storage();
export const db = firebase.database();
export const user = firebase.auth();
